import React from "react";
import PageLayout from "./PageLayout";
import SummerProgram from "../sections/SummerProgram";

export default function SummerPage() {
    return (
        <PageLayout testId="summer-page" pageTitle="Yay proqramı">
            <SummerProgram standalone />
        </PageLayout>
    );
}
